module.exports = __webpack_public_path__ + "static/media/thumbnail.151b8a70.jpg";